import { render, staticRenderFns } from "./QuotaSale.vue?vue&type=template&id=150bfaf2&scoped=true"
import script from "./QuotaSale.vue?vue&type=script&lang=js"
export * from "./QuotaSale.vue?vue&type=script&lang=js"
import style0 from "./QuotaSale.vue?vue&type=style&index=0&id=150bfaf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bfaf2",
  null
  
)

export default component.exports